import { TypographyStyles } from './typographyStyles';
import { ColorStyles } from './colourStyles';
import { ButtonStyles } from './buttonStyles';
import { InputStyles } from './inputStyles';

const GlobalStyles = {
  ...TypographyStyles,
  ...ColorStyles,
  ...ButtonStyles,
  ...InputStyles,
};

export default GlobalStyles;
